import React from 'react';
import { CTAButton } from './CTAButton';
export function EmotionalClose() {
  return <section id="oferta" className="w-full bg-gradient-to-b from-white to-pink-soft py-12 md:py-20 px-4" data-id="element-37">
      <div className="max-w-[680px] mx-auto text-center" data-id="element-38">
        <div className="font-body text-dark-gray text-lg md:text-xl leading-relaxed space-y-4 mb-8" data-id="element-39">
          <p data-id="element-40">Hace un tiempo que estás pensando en aprender esto.</p>
          <p data-id="element-41">
            Viste los videos. Guardaste los tutoriales. Te dijiste "algún día".
          </p>
        </div>

        <p className="font-heading font-bold text-2xl md:text-4xl text-dark-gray mb-8" data-id="element-42">
          Hoy es ese día.
        </p>

        <div className="font-body text-dark-gray text-base md:text-lg leading-relaxed space-y-4 mb-8" data-id="element-43">
          <p data-id="element-44">
            Por menos de lo que cuesta un café, tenés un sistema completo que te
            lleva de cero a una bikini terminada — una que hiciste con tus
            propias manos.
          </p>
          <p data-id="element-45">
            Y la próxima vez que alguien te pregunte "¿dónde conseguiste eso?"
          </p>
        </div>

        <p className="font-heading font-bold text-2xl md:text-3xl text-pink-dark mb-10" data-id="element-46">
          Vas a poder decir: "Lo hice yo."
        </p>

        {/* Price Block */}
        <div className="border-2 border-pink-light bg-beige rounded-2xl p-8 text-center mb-8" data-id="element-47">
          <p className="font-body text-medium-gray text-lg line-through mb-1" data-id="element-48">
            $19.99
          </p>
          <div className="flex items-center justify-center gap-3 mb-2" data-id="element-49">
            <p className="font-heading font-bold text-5xl md:text-6xl text-pink-dark" data-id="element-50">
              $6.36
            </p>
            <span className="bg-pink-dark text-white font-body font-bold text-sm md:text-base px-3 py-1 rounded-full" data-id="element-51">
              -68% OFF
            </span>
          </div>
          <p className="font-body text-medium-gray text-sm" data-id="element-52">
            solo hoy — precio especial de lanzamiento
          </p>
        </div>

        {/* CTA Final */}
        <CTAButton size="large" onClick={() => window.open('https://www.yennilemon.com/cart/44201631187079:1', '_blank')} data-id="element-53">
          👉 SÍ — Dame Acceso Inmediato por $6.36
        </CTAButton>

        <p className="text-center text-medium-gray font-body text-sm mt-4" data-id="element-54">
          Entrega inmediata por email. Garantía de 7 días. Empezá en los
          próximos 5 minutos.
        </p>
      </div>
    </section>;
}